<template>
  <div class="keybox">
    <div class="inputbox">
      <div class="arrbox">
        <div v-for="(item,index) in labelarr" :key="index" class="spanbox">
          <span>{{item}}</span>
          <i class="spanclose" @click="removeitem(index,item)"></i>
        </div>
        <el-autocomplete
          value-key="keyContent"
          placeholder="输入后回车"
          size="200"
          v-model="currentval"
          @keyup.native="addlabel"
          class="input"
          :fetch-suggestions="querySearchAsync"
          @select="handleSelect"
        ></el-autocomplete>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelInput',
  props: {
    parentarr: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      currentval: '',
      labelarr: []
    }
  },
  watch: {
    labelarr (old, cur) {
      console.log(this.labelarr)
      this.$emit('on-change', this.labelarr)
    },
    parentarr () {
      console.log(this.parentarr)
      if (this.parentarr.length > 0) {
        this.labelarr = []
        for (let i = 0; i < this.parentarr.length; i++) {
          this.labelarr.push(this.parentarr[i])
        }
      } else {
        this.labelarr = []
      }
    }
  },
  methods: {
    clear () {
      this.labelarr = [];
    },
    querySearchAsync (queryString, cb) {
      console.log(queryString, 'queryString')
      let url = queryString ? '/question/selQuestionKeyByKeyContext' : '/question/selHostKey';
      this.$axios.post(url, this.$qs.stringify({ keyContent: queryString })).then(res => {
        if (res.data.code === '0') {
          queryString ? cb(res.data.data) : cb(res.data.data.records);
        } else {
          let arr = []
          cb(arr);
        }
      })
    },
    handleSelect (item) {
      this.currentval = item.keyContent;
      this.addlabel()
    },
    // 移除标签
    removeitem (index, item) {
      this.labelarr.splice(index, 1)
    },
    // input回车加入labelarr中
    addlabel (e) {
      console.log(this.currentval, e)
      // 分号或者enter
      if (!e || e.code === 'Semicolon' || e.code === 'Enter') {
        if (!this.currentval) { return }
        let count = this.labelarr.indexOf(this.currentval)
        if (count === -1) {
          this.labelarr.push(this.currentval.replace(';', '').replace('；', ''))
        }
        this.currentval = ''
      }
    }
  }
}
</script>
<style>
.inputbox .el-input input,
.inputbox .el-input input:hover,
.inputbox .el-input input:focus {
  border: none !important;
  box-shadow: none !important;
}
</style>
<style scoped lang='scss'>
.inputbox {
  background-color: white;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 6px;
  margin-bottom: 18px;
  padding: 6px 1px 1px 6px;
  text-align: left;
  font-size: 0;
  margin-bottom: 0;
}
.keybox{
  .input {
    font-size: 14px;
    border: none;
    box-shadow: none;
    outline: none;
    background-color: transparent;
    padding: 0;
    margin: 0;
    // width: auto !important;
    // max-width: inherit;
    width: 100%;
    min-width: 80px;
    vertical-align: top;
    height: 30px;
    color: #34495e;
    margin: 2px;
    line-height: 30px;
    /deep/.el-input__inner{
        border: none;
    }
  }
}

.arrbox {
  border-radius: 6px;
  margin-bottom: 10px;
  padding: 6px 1px 1px 6px;
  text-align: left;
  font-size: 0;
}

.spanbox {
  line-height: 30px;
  margin: 2px;
  padding: 0 10px;
  background-color: #1abc9c;
  color: white;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  overflow: hidden;
  transition: 0.25s linear;
}

.spanbox:hover {
  padding: 0px 17px 0 3px;
}

.spanclose {
  color: white;
  padding: 0 10px 0 0;
  cursor: pointer;
  font-size: 12px;
  position: absolute;
  right: -3px;
  text-align: right;
  text-decoration: none;
  top: 0;
  width: 100%;
  bottom: 0;
  z-index: 2;
  opacity: 0;
  filter: "alpha(opacity=0)";
  transition: opacity 0.25s linear;
  font-style: normal;
}

.spanbox:hover .spanclose {
  padding: 0 10px 5px 0;
  opacity: 1;
  -webkit-filter: none;
  filter: none;
}

.spanclose:after {
  content: "x";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 27px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/page/LabelInput.vue